import { z } from 'zod';
import { MissionType } from '@prisma/client';

export const missionCompletionType = z.literal(MissionType.WeeklyLogin);
export type MissionCompletionType = z.infer<typeof missionCompletionType>;
